import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { youtubeParser } from "../../../../../../utils/video-playlist";

const youtubeRegex =
  /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;

const youtubeLongRegex =
  /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s\?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s\?]+)/;

const URL_REGEX =
  /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

const AddEditPlaylistVideo = ({
  videoFormState,
  handleInputVideoChange,
  validationVideoSubmit,
  handleVideoSubmit,
  setAddNewState,
  setStatusEditState,
}) => {
  const { t } = useTranslation("coaching-portal");
  const youtubeId = youtubeParser(videoFormState.url);

  return (
    <div className="dashed-box add-video-wrapper">
      {youtubeId ? (
        <img
          src={`https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`}
          alt={t("widgets.addEditPlaylistVideo.thumbnail")}
          loading="lazy"
        />
      ) : (
        <div className="dashed-box">
          <p>{t("widgets.addEditPlaylistVideo.thumbnail")}</p>
          <p className="p4">
            {t("widgets.addEditPlaylistVideo.thumbnailPreviewHint")}
          </p>
        </div>
      )}
      <div>
        <label> {t("widgets.addEditPlaylistVideo.videoName")} </label>
        <input
          name="name"
          className="input-videoplaylist-name text-input"
          placeholder={t("widgets.addEditPlaylistVideo.enterName")}
          value={videoFormState.name}
          onChange={handleInputVideoChange}
        />
        <label> {t("widgets.addEditPlaylistVideo.youtubeVideoUrl")} </label>
        <input
          name="url"
          className="input-videoplaylist-name text-input"
          placeholder={t("widgets.addEditPlaylistVideo.pasteYoutubeUrlPlaceholder")}
          value={videoFormState.url}
          onChange={handleInputVideoChange}
        />
        <div className="flex flex-row gap-2">
          <button
            data-button-type="primary"
            onClick={handleVideoSubmit}
            disabled={!validationVideoSubmit()}
          >
            {t("widgets.common.save")}
          </button>
          <button
            data-button-type="text-white"
            data-action="cancel"
            onClick={() => {
              if (!!setStatusEditState) {
                setStatusEditState("initial");
              } else {
                setAddNewState(false);
              }
            }}
          >
            {t("widgets.common.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditPlaylistVideo;
